module.exports = __webpack_public_path__ + "img/yuangongfankui.a850e962.png";